export const isSafari = (): boolean => {
  const userAgent = navigator.userAgent;
  return /^((?!chrome|android).)*safari/i.test(userAgent);
};

export const isChrome = (): boolean => {
  const userAgent = navigator.userAgent;
  return /chrome/i.test(userAgent) && !/edge|opr\//i.test(userAgent);
};
